import { memo } from 'react';
import Latex from 'react-latex-next';

import type { ComponentType } from 'react';

const LatexComponent = Latex as ComponentType<{
	children?: string;
	className?: string;
	strict?: boolean;
}>;

interface LatexTextProps {
	children: string;
}

function normalizeLatexControlCharacters(text: string) {
	return text.replace(/\f(?=rac\b)/g, '\\f');
}

const LatexText = ({ children }: LatexTextProps) => {
	const normalizedChildren = normalizeLatexControlCharacters(children);

	return (
		<LatexComponent className="ai-tutor__latex-text" strict>
			{normalizedChildren}
		</LatexComponent>
	);
};

export default memo(LatexText);
